import axios from 'axios'
import {ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  CleaningActivitiesBodyModel,
  CleaningActivitiesColumnModel,
  CleaningActivitiesDto,
  DeleteActivityDto,
  UpdateActivitySettingModel,
} from '../model/creationCleaningActivities.model'
import {ResponseObject} from '../model/response.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const CREATION_CLEANING_ACTIVITIES_SERVICES = {
  getByServiceSchedulingId: (dto: CleaningActivitiesDto) => {
    return axios.post<any>(`${BASEURL}/ActivitySettings/getByServiceSchedulingId`, dto)
  },
  getCleaningActivitiesList: (dto: CleaningActivitiesDto) => {
    return axios.post<ResponseObjectPaginated<CleaningActivitiesColumnModel[]>>(
      `${BASEURL}/ActivitySettings/getList`,
      dto,
    )
  },
  createCleaningActivity: async (dto: CleaningActivitiesBodyModel) => {
    return await axios.post<ResponseObjectUpload>(
      `${BASEURL}/ActivitySettings/createActivitySettings`,
      dto,
    )
  },
  editCleaningActivity: async (dto: CleaningActivitiesBodyModel) => {
    return await axios.put<ResponseObjectUpload>(
      `${BASEURL}/ActivitySettings/updateActivitySettings`,
      dto,
    )
  },
  getQrActivityById: async (id: string) => {
    return await axios.post(
      `${BASEURL}/ActivitySettings/GenerateQR`,
      {},
      {
        params: {
          activitySettingsId: id,
        },
        responseType: 'arraybuffer',
      },
    )
  },
  updateOrderNumber: async (dto: {id: string; nroOrden: string}) => {
    return await axios.put<ResponseObjectUpload>(
      `${BASEURL}/ActivitySettings/updateOrderNumber`,
      {},
      {
        params: {
          id: dto.id,
          nroOrden: dto.nroOrden,
        },
      },
    )
  },
  downloadMasiveQR: async (dto: CleaningActivitiesDto) => {
    return await axios.post(`${BASEURL}/ActivitySettings/getDownloadQR`, dto, {
      responseType: 'arraybuffer',
    })
  },
  getCleaningActivityById: async (id: string) => {
    return await axios.get<ResponseObject<CleaningActivitiesColumnModel>>(
      `${BASEURL}/ActivitySettings/getActivitySettingsById`,
      {
        params: {
          activitySettingsId: id,
        },
      },
    )
  },
  updateActivity: async (dto: UpdateActivitySettingModel) => {
    return await axios.put<ResponseObjectUpload>(
      `${BASEURL}/ActivitySettings/updateActivitySetting`,
      {},
      {
        params: {
          id: dto.id,
          MinutosPromedio: dto.MinutosPromedio,
          EstadoActividadId: dto.EstadoActividadId,
        },
      },
    )
  },
  deleteActivitySetting: async (dto: DeleteActivityDto) => {
    return await axios.post<ResponseObjectUpload>(
      `${BASEURL}/ActivitySettings/deleteActivitySetting`,
      dto,
    )
  },
}
